import React from "react";
import Header from "~/components/Header";
import ModelView from "~/components/ModelView";
import ChatHistory from "~/components/chat/ChatHistory";
import ControlButton from "~/components/ControlButton";

interface BaseLayoutProps {
  isSettingOpen: boolean;
  isStandbymode: boolean;
}

const ChatPageLayout2: React.FC<BaseLayoutProps> = ({ isSettingOpen, isStandbymode }) => {
  return (
    <>
      <Header />
      <div className={`main-contents-layout-2 ${isSettingOpen ? "open" : ""}`}>
        {/* キャラクターセクション - ヘッダー下、画面の30% */}
        <div className="character-section-layout-2">
          <div className="character-area-layout-2">
            <ModelView visible={!isStandbymode} />
          </div>
        </div>

        {/* チャットセクション - 残りの空間 */}
        <div className="chat-section-layout-2">
          <div className="chat-space">
            <div className="chat-container">
              <ChatHistory />
            </div>
          </div>
        </div>

        {/* 入力セクション - 下部固定 */}
        <div className="input-section-layout-2">
          <ControlButton />
        </div>
      </div>
    </>
  );
};

export default ChatPageLayout2;
